import { render, staticRenderFns } from "./UnfollowPatents.vue?vue&type=template&id=38af92d2&scoped=true"
import script from "./UnfollowPatents.vue?vue&type=script&lang=ts"
export * from "./UnfollowPatents.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "38af92d2",
  null
  
)

export default component.exports